module.exports = __webpack_public_path__ + "static/upcoming-050a35924db7624e62725f412c817c4c.jpg";